import createSvgIcon from '../Utils/CreateSvgIcon';

export const Search = createSvgIcon(
  <path
    d="M16.7619 17.969C15.3146 19.1113 13.4869 19.793 11.5 19.793C6.80562 19.793 3.00004 15.9874 3.00004 11.293C3.00004 6.59855 6.80562 2.79297 11.5 2.79297C16.1945 2.79297 20 6.59855 20 11.293C20 13.2798 19.3183 15.1075 18.1761 16.5548L21.2072 19.5859L19.7929 21.0001L16.7619 17.969ZM18 11.293C18 14.8828 15.0899 17.793 11.5 17.793C7.91019 17.793 5.00004 14.8828 5.00004 11.293C5.00004 7.70312 7.91019 4.79297 11.5 4.79297C15.0899 4.79297 18 7.70312 18 11.293Z"
    fillRule="evenodd"
  />,
  'Search',
);
